import { LevelType } from '@com-delta-idp/mnx-skymiles-shared';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import { AEMImage } from './common.interfaces';

export interface Item {
  image: AEMImage;
  redeemLink: Link;
  title: string;
  type: LevelType;
}

export interface AEMUpgrades {
  items: Item[];
  link: Link;
  title: string;
}
